import type { AdminUsersQuery, AuditQuery } from '@forest/contracts';

export const queryKeys = {
  auth: {
    session: () => ['auth', 'session'] as const,
  },
  me: () => ['me'] as const,
  categories: (params?: { includeInactive?: boolean }) =>
    ['categories', params ?? {}] as const,
  investments: {
    list: (parcelId: string) => ['investments', parcelId] as const,
  },
  imports: {
    batches: () => ['imports', 'batches'] as const,
  },
  admin: {
    users: (params: Partial<AdminUsersQuery>) => ['admin', 'users', params] as const,
    audit: (params: Partial<AuditQuery>) => ['admin', 'audit', params] as const,
  },
};
